import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './lib/sentry';
import { ErrorBoundary } from './components/ErrorBoundary';
import { App } from './App';
import { ToastProvider } from './components/ui/toast';
import { resolveHostContext } from './lib/domain-context';
import './index.css';

/**
 * On a platform host resolveHostContext() returns immediately (no request) and
 * this is the same synchronous boot it always was. On a tenant's custom domain
 * it costs one round-trip before first paint — deliberate: the resolution
 * decides the entire route table, and mounting the dashboard first would flash
 * Foxet chrome at a prospect on their vendor's domain.
 */
async function boot() {
  const domainContext = await resolveHostContext();
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary level="app">
        <BrowserRouter>
          <ToastProvider>
            <App domainContext={domainContext} />
          </ToastProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}

void boot();
